module.exports = __webpack_public_path__ + "img/laura_bern_ocular.1e1d8cd5.jpg";